<template>
  <div v-if="shipping.status === 'INTRANSIT' && eta.from && eta.to">
    <b-alert variant="primary" :show="!notToday">
      <h4 v-translate>Estimated time range for delivery</h4>
      <h5 v-translate="{etaFrom: this.eta.fromTime, etaTo: this.eta.toTime}">Your shipping is expected to be delivered between <strong>%{etaFrom}</strong> and <strong>%{etaTo}</strong> today.</h5>
      <p class="mb-0" v-translate>NOTICE: The delivery time range is approximate and will be updated based on the shipping evolution.</p>
    </b-alert>
    <b-alert variant="warning" :show="notToday">
      <h4 v-translate>We are so sorry 😞</h4>
      <p v-translate>Unfortunately we will not be able to deliver your shipping today. We apologize.</p>

      <p class="mb-0" v-translate>Don't worry, during tomorrow we will be making the delivery as a priority. Through this same link, you will be able to track once it is updated.</p>
    </b-alert>
  </div>
</template>

<script>
  export default {
    name: 'ShippingEtaBox',
    props: {
      shipping: {
        type: Object,
        required: true,
        default: () => {}
      }
    },
    data() {
      return {
        eta: {
          from: null,
          fromTime: '',
          to: null,
          toTime: ''
        },
        notToday: false
      }
    },
    watch: {
      'shipping': {
        deep: true,
        handler(newValue, oldValue) {
          console.log(JSON.stringify(newValue) !== JSON.stringify(oldValue))
          if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
            this.getShippingEta()
          }
        }
      }
    },
    mounted() {
      // this.getShippingEta()
    },
    methods: {
      getShippingEta() {
        if (this.shipping.status === 'INTRANSIT' && (this.moment().utc().tz(this.$tz).startOf('day') - this.moment.utc(this.shipping.status_history[0].created_at).tz(this.$tz).startOf('day')) === 0) {
          this.$http.get(this.$appConfig.api.baseUrl + 'guest/shippings/' + this.shipping.id + '/eta')
            .then(r => {
              console.log(r)
              // r.body = {ETC: 47.4, MIN: 47.4, PLUS: 64.4}
              this.eta.from = this.moment().utc().tz(this.$tz).add(r.body.ETC - r.body.MIN, 'minutes')
              this.eta.fromTime = r.body.ETC === r.body.MIN ? this.$gettext('now') : this.$gettextInterpolate(this.$gettext('the %{fromTime}'), {fromTime: this.eta.from.format('LT')})
              this.eta.to = this.moment().utc().tz(this.$tz).add(r.body.ETC + r.body.PLUS, 'minutes')
              this.eta.toTime = this.eta.to.format('LT')
              console.log(this.moment.duration(this.moment().utc().tz(this.$tz).startOf('day').add(22.5, 'hours') - this.eta.from).asHours())
              console.log(this.moment.duration((this.eta.to - this.eta.from) / 2).asHours())
              console.log(this.eta)
              if (this.moment.duration(this.moment().utc().tz(this.$tz).startOf('day').add(23.99, 'hours') - this.eta.from).asHours() < this.moment.duration((this.eta.to - this.eta.from) / 2).asHours()) {
                this.notToday = true
              }
            })
        } else {
          this.eta = {
            from: null,
            fromTime: '',
            to: null,
            toTime: ''
          }
        }
      }
    }
  }
</script>
